import { c as _c } from "react/compiler-runtime";
import { Text } from '@extern/ui/text';
import { TagIcon } from '@phosphor-icons/react';
import Image from 'next/image';
import GiftImg from '@/public/images/img-shop.png';
export function BlackFridayGiftHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col items-start gap-6 rounded-3xl bg-position-[right_70px_bottom] bg-role-background-invert bg-no-repeat px-6 pt-6 md:min-h-[252px] md:bg-[url('/images/img-shop.png')] md:bg-size-[auto_80%] md:py-8"><div className="mx-auto flex items-center justify-center gap-2 rounded-full bg-role-alert px-3 py-1 text-role-on-background-invert md:mx-0"><TagIcon size={16} weight="fill" />Limited offer</div><Text className="w-full text-center font-normal text-role-on-background-invert md:max-w-1/2 md:text-left md:text-[48px] md:leading-[52px]" heading="lg">Gift a subscription</Text><Text className="text-center text-[18px] text-role-on-background-invert leading-[24px] md:max-w-2/3 md:text-left">For a limited time, save on 6/12-month Extern Gifts. Give someone career-ready experience at a lower price.</Text><Image alt="Gift" className="mx-auto -mt-1 md:hidden" height={150} src={GiftImg} width={150} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}